export const INCIDENT_CATEGORY = "categoryName";
export const DESCRIPTION = "description";
